import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VeeValidate, { Validator } from 'vee-validate'
import VeLine from 'v-charts/lib/line.common'
import 'normalize.css'
import './lib/element-theme/index.css'
import './i18n'
import './config'
import './style/global.styl'
import db from './db'
import lineClamp from 'vue-line-clamp'
import 'babel-polyfill'
import 'es6-promise/auto'
import InfiniteLoading from 'vue-infinite-loading'
import { IEVersion } from './util'
// import preview from 'vue-photo-preview'
// import 'vue-photo-preview/dist/skin.css'

// Vue.use(preview)
const dictionary = {
  en: {
    messages: {
      max: (fieldName) => {
        switch (fieldName) {
          case 'intro_field':
            return 'Introduction no more than 500 characters.'
          case 'remark_field':
            return 'Remark no more than 500 characters.'
          case 'name_field':
            return 'Name no more then 100 characters'
        }
      }
    }
  },
  zh: {
    messages: {
      max: (fieldName) => {
        switch (fieldName) {
          case 'intro_field':
            return '介绍不多于500字'
          case 'remark_field':
            return '备注不多于500字'
          case 'name_field':
            return '名称不多于100字'
        }
      }
    }
  }
}

// Override and merge the dictionaries
Validator.localize(dictionary)

Vue.mixin({
  computed: {
    isView () {
      return this.$route.query.status === 'completed'
    }
  }
})
const vvconfig = {
  locale: db.lang,
  events: 'blur',
  fieldsBagName: 'VeeValidateFields'// change if property conflicts.
}

Vue.prototype.IE = (IEVersion() !== -1)
Vue.use(VeeValidate, vvconfig)

Vue.component(VeLine.name, VeLine)

Vue.config.productionTip = false

Vue.use(lineClamp)

Vue.use(InfiniteLoading, {
  props: {
    spinner: 'spiral'
  },
  slots: {
    noResults: Vue.prototype.$t('暂无数据'),
    noMore: ''
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
